import axios, { AxiosError, AxiosResponse } from "axios";
import VError from "verror";

const wwwAuthHeaderKey = "www-authenticate";

export type MsWwwAuthHeader = {
  type: string;
  proposedAction?: string;
  scopes?: string;
  consentUri?: string;
  _allProps: Map<string, string>;
  _plain: string;
};

export function isInteractionRequiredError(error: any): error is AxiosError {
  if (!axios.isAxiosError(error)) {
    return false;
  }
  if (!error.response) {
    return false;
  }

  switch (error.response.status) {
    case 401:
    case 403:
      if (error.response.headers[wwwAuthHeaderKey] !== undefined) {
        return true;
      }
  }
  return false;
}

export function getWwwAuthHeader(res: AxiosResponse) {
  const wwwAuthHeaderString = res.headers[wwwAuthHeaderKey];

  if (wwwAuthHeaderString === undefined) {
    throw new Error(`${wwwAuthHeaderKey} 헤더 값이 존재하지 않습니다`);
  }

  return parseMsWwwAuthHeader(wwwAuthHeaderString);
}

function parseMsWwwAuthHeader(value: string): MsWwwAuthHeader {
  try {
    /*
     * 샘플값: "Bearer consentUri=\"https://login.microsoftonline.com/a72d26fc-8d4b-43f6-9368-e29a877c9153//oauth2/v2.0/authorize?client_id=c69be6e9-ba09-4e38-a8d0-8acac86cf7d4&response_type=code&redirect_uri=http://localhost/signin-oidc&response_mode=query&scope=offline_access%20user.readwrite.all\", claims=\"\", scopes=\"user.readwrite.all\", proposedAction=\"consent\""
     */
    const [first, ...rest] = value.split(", ");
    const [type, rest2] = first.split(" ");
    const props = new Map<string, string>();

    [...rest, rest2].forEach((x) => {
      const [k, v] = x.split('="');
      props.set(k, v.substr(0, v.length - 1));
    });

    return {
      type,
      proposedAction: props.get("proposedAction"),
      scopes: props.get("scopes"),
      consentUri: props.get("consentUri"),
      _allProps: props,
      _plain: value,
    };
  } catch (error) {
    const message = `${wwwAuthHeaderKey} 헤더 파싱 중 예상하지 못한 오류 발생`;
    if (error instanceof Error) {
      throw new VError(error, message);
    }
    throw new Error(`${message}: ${error}`);
  }
}
